'use client';

import type { ReactNode } from 'react';
import { useLoyaltyContext } from '@libs/common-next';
export function OfferPattern(t0) {
  const {
    children
  } = t0;
  const {
    isLoyaltyUnavailable
  } = useLoyaltyContext();
  if (isLoyaltyUnavailable) {
    return null;
  }
  return children;
}